import { AIService } from './AIService';
import { PlaylistGenerationService } from './PlaylistGeneration';
import { PlaylistModificationService } from './PlaylistModification';
import { PlaylistAnalysisService } from './PlaylistAnalysis';
import { extractPlaylistFromResponse, cleanResponseText } from './utils';

// Export types
export * from './types';

// Create service instances
const coreAIService = new AIService();
const playlistGenerationService = new PlaylistGenerationService(coreAIService);
const playlistModificationService = new PlaylistModificationService(coreAIService);
const playlistAnalysisService = new PlaylistAnalysisService(coreAIService);

// Enhanced AI service that combines all functionality
export class EnhancedAIService {
  // Core AI methods
  public sendMessage = coreAIService.sendMessage.bind(coreAIService);
  public resetConversation = coreAIService.resetConversation.bind(coreAIService);
  public getConversationHistory = coreAIService.getConversationHistory.bind(coreAIService);
  
  // Music recommendation methods
  public getMusicRecommendations = coreAIService.getMusicRecommendations.bind(coreAIService);
  
  // Playlist generation methods
  public generatePlaylist = playlistGenerationService.generatePlaylist.bind(playlistGenerationService);
  public verifyPlaylistWithSpotify = playlistGenerationService.verifyPlaylistWithSpotify.bind(playlistGenerationService);
  
  // Playlist modification methods
  public modifyPlaylist = playlistModificationService.modifyPlaylist.bind(playlistModificationService);
  public transformPlaylist = playlistModificationService.transformPlaylist.bind(playlistModificationService);
  public mergePlaylists = playlistModificationService.mergePlaylists.bind(playlistModificationService);
  
  // Playlist analysis methods
  public analyzePlaylist = playlistAnalysisService.analyzePlaylist.bind(playlistAnalysisService);
  
  // Utility methods
  public extractPlaylistFromResponse = extractPlaylistFromResponse;
  public cleanResponseText = cleanResponseText;
}

// Create and export singleton instance
export const aiService = new EnhancedAIService();
